import simpleAction from './simpleActions';

export const setDirection = (value) => simpleAction('DIRECTION', value);

export const setOrder = (value) => simpleAction('ORDER', value);
